import { useEffect, useState, useRef } from "react";

export function useTvSlideshowEngine(menu) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [showInterImage, setShowInterImage] = useState(false);
  const [loadedImages, setLoadedImages] = useState({});

  const imageCache = useRef({});

  const STATE_NORMAL = "NORMAL";
  const STATE_INTER = "INTER";

  // --- NEW: Skip empty categories ---
  const filteredMenu = menu.filter(
    (cat) => Array.isArray(cat.items) && cat.items.length > 0
  );

  // Preload all images
  const preloadImages = (categoryOrMenu) => {
    const categories = Array.isArray(categoryOrMenu)
      ? categoryOrMenu
      : [categoryOrMenu];

    categories.forEach((category) => {
      if (!category?.items) return;

      category.items.forEach((item) => {
        if (item.imageUrl && !imageCache.current[item.imageUrl]) {
          const img = new Image();
          img.src = item.imageUrl;

          img.onload = () => {
            setLoadedImages((prev) => ({ ...prev, [item.imageUrl]: true }));
          };

          imageCache.current[item.imageUrl] = img;
        }
      });
    });
  };

  // Initial preload
  useEffect(() => {
    if (filteredMenu.length) preloadImages(filteredMenu);
  }, [filteredMenu]);

  // Slideshow loop
  useEffect(() => {
    if (!filteredMenu.length) return;

    preloadImages(filteredMenu[currentIndex]);

    let timer = 0;
    let currentState = STATE_NORMAL;

    const PAGE_DURATION = 12;
    const INTER_DURATION = 10;

    const loop = setInterval(() => {
      timer++;

      if (currentState === STATE_INTER) {
        if (!showInterImage) setShowInterImage(true);

        if (timer >= INTER_DURATION) {
          timer = 0;
          setShowInterImage(false);

          const nextIndex =
            currentIndex + 1 >= filteredMenu.length
              ? 0
              : currentIndex + 1;

          setCurrentIndex(nextIndex);
          setCurrentPage(0);
          preloadImages(filteredMenu[nextIndex]);

          currentState = STATE_NORMAL;
        }
        return;
      }

      if (currentState === STATE_NORMAL) {
        if (timer >= PAGE_DURATION) {
          timer = 0;

          const category = filteredMenu[currentIndex];
          const totalPages = Math.ceil(category.items.length / 3);

          if (currentPage + 1 >= totalPages) {
            currentState = STATE_INTER;
          } else {
            setCurrentPage((prev) => prev + 1);
          }
        }
      }
    }, 1000);

    return () => clearInterval(loop);
  }, [filteredMenu, currentIndex, currentPage, showInterImage]);

  // Items for current page
  const getItemsForCurrentPage = () => {
    if (!filteredMenu.length) return [];

    const category = filteredMenu[currentIndex];
    const items = category.items;

    const result = [];
    for (let i = 0; i < 3; i++) {
      const item = items[(currentPage * 3 + i) % items.length];
      if (item) result.push(item);
    }

    return result;
  };

  return {
    currentIndex,
    currentPage,
    showInterImage,
    imageCache,
    getItemsForCurrentPage,
    loadedImages,
    filteredMenu, // useful outside if needed
  };
}
